import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingIconButtonComponent } from '@app-components/common/loading-icon-button/loading-icon-button.component';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-star-button',
  templateUrl: './star-button.component.html',
  styleUrls: ['./star-button.component.scss'],
  imports: [TranslateModule, LoadingIconButtonComponent, MatIcon, MatMenuItem],
})
export class StarButtonComponent {
  @Input() iconFull = false;
  @Input() isMenu = false;
  @Input() showLoading = false;

  constructor() {}
}
